import styled from 'styled-components';
import { mediaQuery } from '../../common/styles/styleUtil';

export const HighlightCardWrapper = styled.a`
  display: flex;
  margin-bottom: 23px;
  border: 1px solid #a5adb5;
  border-radius: 3px;
  height: 70px;

  &:last-of-type {
    margin-bottom: 0;
  }

  @media (${mediaQuery.tablet}) {
    margin-bottom: 0;
  }

  @media (${mediaQuery.mobile}) {
    height: 69px;
  }

  .body {
    display: flex;
    align-items: center;
    flex-grow: 1;
    justify-items: center;
    padding: 0 16px;

    .content {
      display: -webkit-box;
      font-size: 16px;
      color: #333f48;
      max-height: 54px;
      line-height: 27px;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      font-weight: 400;

      @media (${mediaQuery.mobile}) {
        font-size: 16px;
      }
    }
  }

  &:hover,
  &:focus {
    .body {
      .content {
        text-decoration: underline;
      }
    }
  }
  .image {
    width: 120px;
    height: 100%;
    overflow: hidden;
    flex-shrink: 0;

    @media (${mediaQuery.mobile}) {
      width: 114px;
      height: 100%;
      object-fit: cover;
    }
    .lazy-image-wrapper {
      height: 100%;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
`;
